const addGroups = (state, action) => {
  switch (action.status) {
    case 'started':
      return {
        ...state,
        creatingGroups: true,
      };
    case 'success':
    case 'error':
      return {
        ...state,
        creatingGroups: false,
      };
    default:
      return state;
  }
};

export default addGroups;
